import { Model } from 'pinia-orm';
import { BelongsTo, HasMany, Num, Str } from 'pinia-orm/dist/decorators';
import Package from './Package';
import ScopeGapItem from './ScopeGapItem';
/* --- user header --- */
/* --- end user header --- */

export default class ScopeGapCategory extends Model {
  static entity = 'App\\Models\\ScopeGapCategory';
  // fields
  @Num(0)
  declare id: number;
  @Num(0)
  declare package_id: number;
  @Num(0)
  declare sort_order: number;
  @Str('')
  declare description: string;
  // relations
  @BelongsTo(() => Package, 'package_id', 'id')
  declare package: Package;
  @HasMany(() => ScopeGapItem, 'scope_gap_category_id', 'id')
  declare scope_gap_items: ScopeGapItem[];
  /* --- user code --- */
  /* --- end user code --- */
}
